$(function () {
    const scrollTopButton = $('#scroll-top-button');
    const jWindow = $(window);

    scrollTopButton.click(function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

    function handleScrollTopButton() {
        if (jWindow.scrollTop() > 300) {
            scrollTopButton.css({
                right: '20px'
            });
        } else {
            scrollTopButton.css({
                right: '-100px'
            });
        }
    }

    handleScrollTopButton();

    jWindow.scroll(handleScrollTopButton)
});
